export const header = () => {


	//Hide the header as the users scrolls down, reveal it again if they scroll up
	let pageHeader = document.querySelector('#main-header'),
	scrollTrigger = pageHeader.offsetHeight;

	document.addEventListener('scroll', (event) => {

		if(window.scrollY > scrollTrigger){
				pageHeader.classList.add('header-scrolled');
		}else{
			pageHeader.classList.remove('header-scrolled');
			
		}
		
  		
	});

	
}